import { isFeatureEnabledForProject } from './project-features';

/**
 * Sample collection enablement, shared by the Samples tab, the DWR
 * "+ Create sample" affordance and the acceptance-record dialog. Mirrors
 * ProjectModel.isSampleCollectionEnabled on the API and the mobile helper:
 *  - the org must expose the `sample_record_general` group on appdata
 *    dailyReportFields (that is what ships the feature);
 *  - then the generic project-level rollout applies (see project-features):
 *    org-wide unless the org lists 'sample_collection' in
 *    org_config.project_scoped_features, in which case the project needs
 *    source_entity_extra_attributes.sample_collection_enabled === true.
 */

/**
 * Acceptance-record fields that only exist to launch sample collection. They
 * live on the org-wide material acceptance group, so projects that are not
 * opted in must not render them.
 */
export const SAMPLE_ENTRY_FIELD_NAMES = ['sample_type', 'source_id'];

export function isSampleCollectionEnabled(appData: any, project: any): boolean {
  const fields = appData?.dailyReportFields?.sample_record_general?.fields;
  if (!Array.isArray(fields) || fields.length === 0) {
    return false;
  }
  return isFeatureEnabledForProject('sample_collection', appData, project);
}

export function filterSampleEntryFields<T extends { name?: string }>(fields: T[], sampleEnabled: boolean): T[] {
  if (sampleEnabled) {
    return fields;
  }
  return (fields || []).filter(f => !SAMPLE_ENTRY_FIELD_NAMES.includes(f?.name));
}
